// style
import './style/style.css';

// links
import { useParams } from 'react-router';

// icon
import { IconChevronLeft, IconChevronRight, IconFilter, IconX } from '@tabler/icons-react';

// hook and controller
import useGetData from '../../hook/getData';
import { GetCategoryProducts } from '../../services/client/categories/getCategoryProducts';

// components
import ProductsCard from '../../components/products/products';

// state
import { useEffect, useMemo, useState } from 'react';

// client
import { ClientOption } from '../../config/clientOption';

// axios
import axios from 'axios';

type ParamsType = {
    slug?: string;
};

const Products = () => {
    const params = useParams<ParamsType>();

    const [queryParam, setQueryParam] = useState<string>('');
    const [active, setActive] = useState<string>('');
    const [productCategory, setProductCategory] = useState<any>(null);
    const [searchValue, setSearchValue] = useState<string>('');

    const { data: products, isLoading: productLoading } = useGetData(
        ['categories', params.slug],
        GetCategoryProducts
    );

    useEffect(() => {
        window.scrollTo(0, 0);
        setProductCategory(products);
        document.getElementById('pages-header')?.classList.remove('d-none');
    }, [products]);

    const categoryUrl = useMemo(() => {
        return `${process.env.REACT_APP_API_URL}categories/${params.slug}`;
    }, [params.slug]);

    const getFilter = (paramsData: string) => {
        axios
            .get(paramsData ? `${categoryUrl}?${paramsData}` : categoryUrl, ClientOption)
            .then((response) => {
                setProductCategory(response.data.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const updateQueryAndFetch = (searchParams: URLSearchParams) => {
        const finalQuery = searchParams.toString();
        setQueryParam(finalQuery);
        getFilter(finalQuery);
    };

    const changeProduct = (
        version: 'attr' | 'varia' | 'search' | 'sort',
        id: number | null,
        value: string | null,
        event: any
    ) => {
        const searchParams = new URLSearchParams(queryParam);

        if (version === 'attr' && id !== null && value) {
            const key = `attribute[${id}]`;
            const currentValues = searchParams.get(key);
            let values = currentValues ? currentValues.split('-') : [];

            if (event?.target?.checked) {
                if (!values.includes(value)) {
                    values.push(value);
                }
            } else {
                values = values.filter((item) => item !== value);
            }

            if (values.length > 0) {
                searchParams.set(key, values.join('-'));
            } else {
                searchParams.delete(key);
            }
        }

        if (version === 'varia') {
            if (value && event?.target?.checked) {
                searchParams.set('variation', value);
            } else {
                searchParams.delete('variation');
            }
        }

        if (version === 'search') {
            const inputValue = event?.target?.value?.trim() || '';
            setSearchValue(inputValue);

            if (inputValue) {
                searchParams.set('search', inputValue);
            } else {
                searchParams.delete('search');
            }
        }

        if (version === 'sort') {
            if (value) {
                searchParams.set('sortBy', value);
                setActive(value);
            } else {
                searchParams.delete('sortBy');
                setActive('');
            }
        }

        // با تغییر فیلتر/جستجو/مرتب‌سازی، صفحه برگردد به 1
        searchParams.delete('page');

        updateQueryAndFetch(searchParams);
    };

    const changePage = (page: number) => {
        if (!page || page < 1) return;

        const lastPage = productCategory?.meta?.last_page || 1;
        if (page > lastPage) return;

        const searchParams = new URLSearchParams(queryParam);
        searchParams.set('page', String(page));

        updateQueryAndFetch(searchParams);

        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const getCheckedAttribute = (attributeId: number, attrValue: string) => {
        const key = `attribute[${attributeId}]`;
        const currentValue = new URLSearchParams(queryParam).get(key);
        const checkedValues = currentValue ? currentValue.split('-') : [];
        return checkedValues.includes(attrValue);
    };

    const getCheckedVariation = (variationValue: string) => {
        return new URLSearchParams(queryParam).get('variation') === variationValue;
    };

    return (
        <>
            <section className="bg-white py-md-5 py-4">
                <div className="container">
                    <div className="row gy04">
                        <div className="col-lg-3 d-md-inline-block d-none col-md-4">
                            <div className="card product-swicher position-sticky card-body border-0 shadow rounded rounded-4">
                                <input
                                    value={searchValue}
                                    onChange={(e) => changeProduct('search', null, null, e)}
                                    className="form-control py-3"
                                    type="search"
                                    placeholder="جست و جو..."
                                />

                                <div className="accordion mt-3" id="accordionExample">
                                    {productCategory?.filters?.attributes?.map((item: any, index: number) => (
                                        <div key={item.id + 'attr'} className="accordion-item">
                                            <h2 className="accordion-header" id={`heading-${index}`}>
                                                <button
                                                    className="accordion-button shadow-none bg-white"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse${index}`}
                                                    aria-expanded="true"
                                                    aria-controls={`collapse${index}`}
                                                >
                                                    {item.name}
                                                </button>
                                            </h2>

                                            <div
                                                id={`collapse${index}`}
                                                className="accordion-collapse collapse show"
                                                data-bs-parent="#accordionExample"
                                            >
                                                <div className="accordion-body pt-0">
                                                    <ul className="list-group px-0 py-0 mt-0">
                                                        {item.attribute_values?.map((value: any) => (
                                                            <li key={`${item.id}-${value.value}`} className="list-group-item px-0">
                                                                <div className="d-flex font-medium-lg justify-content-between">
                                                                    <span className="text-muted">{value.value}</span>
                                                                    <div className="form-switch">
                                                                        <input
                                                                            checked={getCheckedAttribute(item.id, value.value)}
                                                                            onChange={(e) => changeProduct('attr', item.id, value.value, e)}
                                                                            className="form-check-input border-black"
                                                                            type="checkbox"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                    {productCategory?.filters?.variation ? (
                                        <div className="accordion-item">
                                            <h2 className="accordion-header" id="heading-variation">
                                                <button
                                                    className="accordion-button shadow-none bg-white collapsed"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapseVariation"
                                                    aria-expanded="false"
                                                    aria-controls="collapseVariation"
                                                >
                                                    {productCategory?.filters?.variation?.name}
                                                </button>
                                            </h2>

                                            <div
                                                id="collapseVariation"
                                                className="accordion-collapse collapse"
                                                aria-labelledby="heading-variation"
                                                data-bs-parent="#accordionExample"
                                            >
                                                <div className="accordion-body pt-0">
                                                    <ul className="list-group px-0 py-0 mt-0">
                                                        {productCategory?.filters?.variation?.variation_values?.map((value: any) => (
                                                            <li key={`${value.value}-desktop`} className="list-group-item px-0">
                                                                <div className="d-flex font-medium-lg justify-content-between">
                                                                    <span className="text-muted">{value.value}</span>
                                                                    <div className="form-switch">
                                                                        <input
                                                                            checked={getCheckedVariation(value.value)}
                                                                            onChange={(e) =>
                                                                                changeProduct('varia', value.attribute_id, value.value, e)
                                                                            }
                                                                            className="form-check-input border-black"
                                                                            type="checkbox"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-9 col-md-8">
                            <div className="card card-body rounded rounded-4 border-0 shadow">
                                <div className="category-type">
                                    <ul className="nav mt-1">
                                        <li className="nav-item filter-font">مرتب سازی بر اساس:</li>

                                        <li
                                            className={
                                                active === 'latest'
                                                    ? 'nav-item px-md-4 px-2 text-site fw-bold'
                                                    : 'nav-item px-md-4 px-2 filter-font'
                                            }
                                            onClick={() => changeProduct('sort', null, 'latest', null)}
                                        >
                                            جدیدترین
                                        </li>

                                        <li
                                            className={
                                                active === 'oldest'
                                                    ? 'nav-item px-md-4 px-2 text-site fw-bold'
                                                    : 'nav-item px-md-4 px-2 filter-font'
                                            }
                                            onClick={() => changeProduct('sort', null, 'oldest', null)}
                                        >
                                            قدیمی ترین
                                        </li>

                                        <li
                                            className={
                                                active === 'max'
                                                    ? 'nav-item px-md-4 px-2 text-site fw-bold'
                                                    : 'nav-item px-md-4 px-2 filter-font'
                                            }
                                            onClick={() => changeProduct('sort', null, 'max', null)}
                                        >
                                            گران ترین
                                        </li>

                                        <li
                                            className={
                                                active === 'min'
                                                    ? 'nav-item px-md-4 px-2 text-site fw-bold'
                                                    : 'nav-item px-md-4 px-2 filter-font'
                                            }
                                            onClick={() => changeProduct('sort', null, 'min', null)}
                                        >
                                            ارزان ترین
                                        </li>
                                    </ul>
                                </div>

                                <div className="row justify-content-center justify-content-md-start gy-4 mt-1">
                                    {productCategory?.products?.length > 0 ? (
                                        <>
                                            {productCategory.products.map((product: any) => (
                                                <div key={product.id} className="col-lg-3 col-md-6 col-6">
                                                    <ProductsCard
                                                        count={product?.quantity}
                                                        rate={product.average_rate}
                                                        price={product?.price}
                                                        has_variation={product.has_variation}
                                                        id={product.id}
                                                        slug={product.slug}
                                                        name={product.name}
                                                        primary_image={product.primary_image}
                                                        description={product.description}
                                                        quantity_check={product.quantity_check}
                                                    />
                                                </div>
                                            ))}

                                            {productCategory?.meta?.last_page > 1 && (
                                                <div className="col-12 d-flex justify-content-center mt-4">
                                                    <nav aria-label="pagination">
                                                        <ul className="pagination" id='pagination'>

                                                            <li
                                                                className={`page-item ${productCategory.meta.current_page === 1 ? 'disabled' : ''
                                                                    }`}
                                                            >
                                                                <button
                                                                    className="page-link"
                                                                    onClick={() =>
                                                                        changePage(productCategory.meta.current_page - 1)
                                                                    }
                                                                    disabled={productCategory.meta.current_page === 1}
                                                                >
                                                                   <IconChevronRight size={16}/>
                                                                </button>
                                                            </li>

                                                            {Array.from(
                                                                { length: productCategory.meta.last_page },
                                                                (_, index) => {
                                                                    const page = index + 1;

                                                                    return (
                                                                        <li
                                                                            key={page}
                                                                            className={`page-item ${productCategory.meta.current_page === page ? 'active' : ''
                                                                                }`}
                                                                        >
                                                                            <button
                                                                                className="page-link"
                                                                                onClick={() => changePage(page)}
                                                                            >
                                                                                {page}
                                                                            </button>
                                                                        </li>
                                                                    );
                                                                }
                                                            )}

                                                            <li
                                                                className={`page-item ${productCategory.meta.current_page ===
                                                                        productCategory.meta.last_page
                                                                        ? 'disabled'
                                                                        : ''
                                                                    }`}
                                                            >
                                                                <button
                                                                    className="page-link"
                                                                    onClick={() =>
                                                                        changePage(productCategory.meta.current_page + 1)
                                                                    }
                                                                    disabled={
                                                                        productCategory.meta.current_page ===
                                                                        productCategory.meta.last_page
                                                                    }
                                                                >
                                                                    <IconChevronLeft  size={16}/>
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </nav>
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            {!productLoading ? (
                                                <div className="row justify-content-center w-100">
                                                    <div className="col-md-6 col-10">
                                                        <img
                                                            src={require('./../../assets/media/global/404.png')}
                                                            alt="404"
                                                            className="error-page-img"
                                                        />
                                                        <p className="mt-3 text-center fw-bold large">
                                                            محصولی پیدا نشد...
                                                        </p>
                                                    </div>
                                                </div>
                                            ) : null}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="modal fade" id="swicher">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-header d-flex justify-content-between">
                            <h5 className="text-site mb-0 fw-bold">انتخاب دسته بندی</h5>
                            <IconX data-bs-dismiss="modal" />
                        </div>

                        <div className="modal-body">
                            <input
                                value={searchValue}
                                onChange={(e) => changeProduct('search', null, null, e)}
                                className="form-control py-3"
                                type="search"
                                placeholder="جست و جو..."
                            />

                            <div className="accordion mt-3" id="accordionExampleMobile">
                                {productCategory?.filters?.attributes?.map((item: any, index: number) => (
                                    <div key={item.id + 'attrmob'} className="accordion-item">
                                        <h2 className="accordion-header" id={`headingMob-${index}`}>
                                            <button
                                                className="accordion-button shadow-none bg-white"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#collapse${index}Mob`}
                                                aria-expanded="true"
                                                aria-controls={`collapse${index}Mob`}
                                            >
                                                {item.name}
                                            </button>
                                        </h2>

                                        <div
                                            id={`collapse${index}Mob`}
                                            className="accordion-collapse collapse show"
                                            data-bs-parent="#accordionExampleMobile"
                                        >
                                            <div className="accordion-body pt-0">
                                                <ul className="list-group px-0 py-0 mt-0">
                                                    {item.attribute_values?.map((value: any) => (
                                                        <li
                                                            key={`${item.id}-${value.value}-mob`}
                                                            className="list-group-item px-0"
                                                        >
                                                            <div className="d-flex font-medium-lg justify-content-between">
                                                                <span className="text-muted">{value.value}</span>
                                                                <div className="form-switch">
                                                                    <input
                                                                        checked={getCheckedAttribute(item.id, value.value)}
                                                                        onChange={(e) => changeProduct('attr', item.id, value.value, e)}
                                                                        className="form-check-input border-black"
                                                                        type="checkbox"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                {productCategory?.filters?.variation ? (
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="headingVariationMob">
                                            <button
                                                className="accordion-button shadow-none bg-white collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseTwoMob"
                                                aria-expanded="false"
                                                aria-controls="collapseTwoMob"
                                            >
                                                {productCategory?.filters?.variation?.name}
                                            </button>
                                        </h2>

                                        <div
                                            id="collapseTwoMob"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingVariationMob"
                                            data-bs-parent="#accordionExampleMobile"
                                        >
                                            <div className="accordion-body pt-0">
                                                <ul className="list-group px-0 py-0 mt-0">
                                                    {productCategory?.filters?.variation?.variation_values?.map((value: any) => (
                                                        <li
                                                            key={`${value.value}-mob-var`}
                                                            className="list-group-item px-0"
                                                        >
                                                            <div className="d-flex font-medium-lg justify-content-between">
                                                                <span className="text-muted">{value.value}</span>
                                                                <div className="form-switch">
                                                                    <input
                                                                        checked={getCheckedVariation(value.value)}
                                                                        onChange={(e) =>
                                                                            changeProduct('varia', value.attribute_id, value.value, e)
                                                                        }
                                                                        className="form-check-input border-black"
                                                                        type="checkbox"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button data-bs-dismiss="modal" className="w-100 btn btn-primary">
                                اعمال فیلتر ها
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-white d-md-none d-inline-block">
                <button
                    className="swicher-btn btn shadow"
                    data-bs-toggle="modal"
                    data-bs-target="#swicher"
                >
                    <IconFilter />
                </button>
            </section>
        </>
    );
};

export default Products;
